module.exports = __webpack_public_path__ + "img/logo.6acb2919.png";